

















import {
  Vue,
  Component,
} from "@/shared/vuepack";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import { HsabSsoDestination } from "@/shared/types";

@Component({
  components: {
    SsoDeepLink,
  }
})
export default class HsabPreferences extends Vue {
  get preferencesDeepLinkLocation () {
    return HsabSsoDestination.MessageCenter;
  }
}
